import React from 'react'
import { Radio, RadioGroupProps } from 'antd'
import styles from './index.less'

export enum OrderTypeEnum {
    /** 全部订单 = NORMAL + SUP */
    ALL = 'ALL',

    /** 自发订单 */
    NORMAL = 'NORMAL',

    /** 供销订单 */
    SUP = 'SUP',
}

interface OrderTypeRadioProps extends Omit<RadioGroupProps, 'value' | 'onChange'> {
    /** 值为订单类型 */
    value: OrderTypeEnum

    /** 选中值改变时的回调 */
    onChange: (value: OrderTypeEnum) => void
}

export default (props: OrderTypeRadioProps) => {
    const { value, onChange, ...restProps } = props

    return (
        <div className={styles.radioWrap}>
            <Radio.Group
                {...restProps}
                className={styles.radioGroup}
                value={value || OrderTypeEnum.ALL}
                onChange={e => onChange(e.target.value)}
            >
                <Radio.Button value={OrderTypeEnum.ALL}>全部</Radio.Button>
                <Radio.Button value={OrderTypeEnum.NORMAL}>自发售后单</Radio.Button>
                <Radio.Button value={OrderTypeEnum.SUP}>供销售后单</Radio.Button>
            </Radio.Group>
        </div>
    )
}
